import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import './style/global.css'
import './plugins/vant.js'
import { Dialog } from 'vant'
import LuckDraw from 'vue-luck-draw'
import cache from '@/utils/cache'
import './permission'
Vue.use(Dialog)
Vue.use(LuckDraw)
cache.loadingCache()
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
